import { config } from "config";
import type { Player } from "quiz/types/player.model";

export class PronosticV2Service {
  private static headers() {
    return {
      Authorization: `Bearer ${JSON.parse(
        sessionStorage.getItem("quizToken")!,
      )}`,
    };
  }

  checkPronosticV2Winner(pronosticV2WinnerCheckData: {
    pronosticV2Id: string;
  }): Promise<string> {
    return fetch(`${config.apiRoot}/check-pronostic-v2-winner-v2`, {
      method: "POST",
      headers: PronosticV2Service.headers(),
      body: JSON.stringify(pronosticV2WinnerCheckData),
    }).then((resp) => resp.json());
  }
  getAllPlayersByPronosticV2(getAllPlayersByPronosticV2Data: {
    pronosticV2Id: string;
    listOfSubPlaces: string;
  }): Promise<string> {
    const query = new URLSearchParams(
      getAllPlayersByPronosticV2Data,
    ).toString();
    return fetch(`${config.apiRoot}/players?${query}`, {
      method: "GET",
      headers: PronosticV2Service.headers(),
    }).then((resp) => resp.json());
  }
  getPronosticV2ById(getPronosticV2ByIdData: {
    pronosticV2Id: string;
  }): Promise<string> {
    return fetch(
      `${config.apiRoot}/pronostics-v2/${getPronosticV2ByIdData.pronosticV2Id}`,
      {
        method: "GET",
        headers: PronosticV2Service.headers(),
      },
    ).then((resp) => resp.json());
  }
  //this should fetch all events
  getAllEvents(): Promise<string> {
    return fetch(`${config.apiRoot}/events`, {
      method: "GET",
      headers: PronosticV2Service.headers(),
    }).then((resp) => resp.json());
  }
  submitPronosticV2Results(data: { playerData: Player }): Promise<any> {
    return fetch(`${config.apiRoot}/submit-pronostic-v2`, {
      method: "POST",
      headers: PronosticV2Service.headers(),
      body: JSON.stringify(data),
    }).then(async (resp) => {
      const json = await resp.json();
      if (!resp.ok) {
        // Special case: late submission
        if (resp.status === 400 && json.error === "Game has Ended") {
          throw new Error("LATE_SUBMISSION");
        }
        throw new Error(json.error || `Error ${resp.status}`);
      }
      return json;
    });
  }
}
